import React from 'react';
import ModalNotificationComponent from '@ui/components/Modal-notification/Modal-notification.component';
import { emptyFn } from '@core/interfaces/emptyFn';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    message: string;
    onClose: emptyFn;
}

const Component: React.FC<IProps> = ({ lang, message, onClose }: IProps) => {
    return (
        <ModalNotificationComponent
            lang={lang}
            message={message}
            onClose={onClose}
        />
    );
};

const SaveConfirmComponent = React.memo(Component);

export default SaveConfirmComponent;
